export const paperStyles = {
    padding: 20 ,
    width: 300,
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
} 

export const loginStyles = {
    width: 260,
    margin: '15px auto',
} 

export const linkStyles = {
    padding: '0',           
    margin: '0',      
    marginTop: '16px',      
    display: 'inline-block',     
    cursor: 'pointer',    
  };
  